import React, { useMemo } from "react";

import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Circle,
  InfoWindow,
  Polyline,
} from "@react-google-maps/api";
import ModalDetailTrip from "components/MonitoringTrips/Modal/DetailTrip";
import { getTripsActive } from "actions/Projects";
import { useTranslation } from "react-i18next";
import { calculateHeading } from "utils";

const MapMonitor = ({
  geofences,
  getDataTripWithRoute,
  conectionSocket,
  isConnect,
  filters,
  projectId,
}) => {
  const { REACT_APP_API_KEY_MAPS } = process.env;
  const [t] = useTranslation("global");
  
  // Función para generar colores aleatorios para los camiones
  const getRandomCabColor = (lastMovementStatus) => {
    const colors = {
      'azul': "#0A6ACF", // Azul
      'verde': "#3B8F1F", // Verde
      'amarillo': "#E8B024", // Amarillo
      'rojo': "#C53A32", // Rojo
    };
    return colors[lastMovementStatus] || "#000000"; // Color por defecto
  };

  // Función para crear el icono del camión usando el componente React
  const createTruckIcon = (rotation, cabColor) => {
    // Función para oscurecer el color
    const darkenColor = (color, factor = 0.7) => {
      const hex = color.replace('#', '');
      const r = Math.floor(parseInt(hex.substr(0, 2), 16) * factor);
      const g = Math.floor(parseInt(hex.substr(2, 2), 16) * factor);
      const b = Math.floor(parseInt(hex.substr(4, 2), 16) * factor);
      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };

    const darkerCabColor = darkenColor(cabColor);

    const svgContent = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.83 25.19" style="transform: rotate(${rotation - 85}deg); transform-origin: center;">
        <!-- CAJA DEL CAMIÓN -->
        <rect x="0" y="1.11" width="43.21" height="22.98" fill="${cabColor}" />
        <rect x="4.25" y="3.37" width="34.71" height="18.46" fill="${cabColor}" />
        <rect x="4.25" y="5.14" width="34.71" height="14.91" fill="${darkerCabColor}" />
        <rect x="4.25" y="6.95" width="34.71" height="11.28" fill="${cabColor}" />
        <rect x="4.25" y="8.71" width="34.71" height="7.76" fill="${darkerCabColor}" />
        <rect x="4.25" y="10.34" width="34.71" height="4.5" fill="${cabColor}" />
        <rect x="4.25" y="11.77" width="34.71" height="1.65" fill="${darkerCabColor}" />
        <rect x="2.17" y="3.37" width="0.93" height="18.44" fill="${cabColor}" />
        <rect x="40.05" y="3.37" width="0.93" height="18.44" fill="${cabColor}" />

        <!-- CABINA (color dinámico) -->
        <rect x="40.05" y="5.41" width="7.37" height="14.37" fill="${cabColor}" />
        <path d="M64.16,19.91c.9-2.35.9-12.28,0-14.63-.62-1.64-.87-3.06-1.67-3.06H61c-.16.39.53.4.85.81a10,10,0,0,1,.82,2.25c.9,2.35.9,12.28,0,14.63a9.7,9.7,0,0,1-.82,2.24c-.32.42-1,.43-.85.82h1.48C63.29,23,63.54,21.55,64.16,19.91Z" fill="#252525" />
        <path d="M46,22.74H61.1c.78,0,1.23-1.25,1.84-2.87.88-2.34.88-12.21,0-14.55-.61-1.62-1.06-2.88-1.84-2.88H46Z" fill="#fff" />
        <path d="M54.69,8.54a20.16,20.16,0,0,1,.41,4h0v.07h0a20.16,20.16,0,0,1-.41,4,19,19,0,0,1-.84,2.92c1.62.76,3.71,1.71,3.71,1.71a12.67,12.67,0,0,0,1.69-4.57,20,20,0,0,0,.42-4.08h0s0,0,0,0v0h0a20,20,0,0,0-.42-4.08,12.6,12.6,0,0,0-1.69-4.57s-2.09,1-3.71,1.71A19,19,0,0,1,54.69,8.54Z" fill="#3c3c3c" />
        <polygon points="56.74 21.78 52.88 19.78 47.42 19.78 47.42 21.82 56.74 21.78" fill="#3c3c3c" />
        <polygon points="56.74 3.4 52.88 5.41 47.42 5.41 47.42 3.37 56.74 3.4" fill="#3c3c3c" />
        <path d="M62.94,19.87a10.81,10.81,0,0,0,.44-2.36,1.75,1.75,0,0,0-.75.23c-.62.41-1.46,3.16-.3,3.66C62.53,21,62.73,20.44,62.94,19.87Z" fill="#e2e4dd" />
        <path d="M62.94,5.32c-.21-.57-.41-1.09-.61-1.53-1.16.5-.32,3.25.3,3.66a1.9,1.9,0,0,0,.75.23A10.81,10.81,0,0,0,62.94,5.32Z" fill="#e2e4dd" />
        <path d="M62.72,20.45l-1-.24A21.3,21.3,0,0,0,61,22.74h.11a.86.86,0,0,0,.4-.13A4.78,4.78,0,0,0,62.72,20.45Z" fill="${cabColor}" />
        <path d="M62.72,4.74A4.78,4.78,0,0,0,61.5,2.58a.88.88,0,0,0-.4-.14H61A21.11,21.11,0,0,0,61.72,5Z" fill="${cabColor}" />
        <path d="M55.5,21.82l0,3.37s.28,0,.67-.4a7.92,7.92,0,0,0,.54-3Z" fill="#fff" />
        <path d="M55.5,21.82l0,3.37s.28,0,.67-.4a7.92,7.92,0,0,0,.54-3Z" fill="#fff" />
        <path d="M55.5,3.37l0-3.37s.28,0,.67.4a7.92,7.92,0,0,1,.54,3Z" fill="#fff" />
      </svg>
    `;

    return {
      url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`,
      scaledSize: new window.google.maps.Size(50, 50),
      anchor: new window.google.maps.Point(25, 25),
    };
  };

  const [activeView, setActiveView] = React.useState();
  const [paths, setPaths] = React.useState();
  const [infoTrip, setInfoTrip] = React.useState(null);
  const [trips, setTrips] = React.useState([]);
  const [zoom, setZoom] = React.useState(5);
  const [visiblePoliLyne, setVisiblePoliLyne] = React.useState(false);
  const [truckColors, setTruckColors] = React.useState({}); // Para almacenar colores por tripId
  const [center, setCenter] = React.useState({
    lat: 18.1932342,
    lng: -101.9061163,
  });

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: REACT_APP_API_KEY_MAPS,
  });
  

  React.useEffect(() => {
    if (projectId) {
      let queryParameters = "";
      if (filters && Object.keys(filters).length > 0) {
        for (const key in filters) {
          queryParameters += `${key}=${filters[key]}&`;
        }
      }
      getTripsActive(projectId, queryParameters).then((response) => {
        if (response?.length === 1) {
          const { currentLocation } = response[0];
          setZoom(16);
          setCenter(currentLocation);
        }
        setTrips(response);
      });
    }
  }, [filters, projectId]);

  React.useEffect(() => {
    if (conectionSocket && isConnect) {
      conectionSocket.on("receiveNewLocationTrip", ({ data }) => {
        const { idTrip, lat, lng, isDangerZone } = data;
        if (!idTrip || lat == null || lng == null) return;
        setTrips((prevTrips) => {
          const currentTrips = prevTrips || [];
          const index = currentTrips.findIndex(
            (item) => Number(item?.trip?.id) === Number(idTrip)
          );
          
          // Si no existe, agregar nuevo viaje
          if (index === -1) {
            const newTrip = {
              currentLocation: { lat, lng, rotation: 0 },
              isDangerZone: !!isDangerZone,
              tripRoutes: [{ latitude: lat, longitude: lng }],
              trip: { id: idTrip },
              isNew: true,
            };
            return [...currentTrips, newTrip];
          }
          
          // Si existe, actualizar
          const updatedTrips = [...currentTrips];
          const trip = { ...updatedTrips[index] };
          const prevLocation = trip.currentLocation;
          const rotation = calculateHeading(
            prevLocation.lat,
            prevLocation.lng,
            lat,
            lng
          );

          trip.currentLocation = { lat, lng, rotation };
          trip.isDangerZone = !!isDangerZone;
          trip.tripRoutes = [
            ...(trip.tripRoutes || []),
            { latitude: lat, longitude: lng },
          ];

          updatedTrips[index] = trip;
          return updatedTrips;
        });

        setPaths((prevPaths) => {
          if (prevPaths?.id === idTrip) {
            return {
              id: idTrip,
              paths: [...prevPaths.paths, { lat, lng }],
            };
          }
          return prevPaths;
        });
      });

      conectionSocket.on("receiveNewTrip", ({ data }) => {
        const tripId = data?.trip?.id;
        if (!tripId) return;
        setTrips((prevTrips) => {
          const currentTrips = prevTrips || [];
          const exists = currentTrips.some((item) => item?.trip?.id === tripId);
          if (exists) return currentTrips;
          const newTrip = {
            currentLocation: null,
            isDangerZone: false,
            tripRoutes: [],
            trip: { id: tripId },
          };
          return [...currentTrips, newTrip];
        });
      });
    }
  }, [conectionSocket, isConnect]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterresTrip = useMemo(() => {
    return trips?.filter((item) => item.currentLocation) ?? [];
  }, [trips]);


  console.log('trips', filterresTrip);

  const zonesGeofences = useMemo(() => {
    return geofences;
  }, [geofences]);

  const handleRenderPolyline = ({ item }) => {
    try {
      if (item.tripRoutes && item.tripRoutes.length > 0) {
        const pathsTrip = item.tripRoutes.map((path) => {
          return {
            lat: path.latitude,
            lng: path.longitude,
          };
        });

        setPaths({
          id: item.trip.id,
          paths: pathsTrip,
        });
        setVisiblePoliLyne(true);
      }
    } catch (error) {
      console.error(error);
    }
    setActiveView(null);
  };

  const handleViewDetailTrip = async ({ item }) => {
    try {
      let tripData = await getDataTripWithRoute(item.trip.id);
      if (tripData) {
        setInfoTrip(tripData);
      }
    } catch (error) {
      console.error(error);
    }
    setActiveView(null);
  };

  const handleRenderInfoView = ({ index, item }) => {
    return (
      <InfoWindow
        onCloseClick={() => setActiveView(null)}
        key={`info_${index}`}
      >
        <div className="space-y-3 text-sm font-[Gravity] text-[#111]">
          <h1 className="text-base font-semibold">🚗 Viaje - {item.trip.id}</h1>
          <button
            className="w-full bg-[#222] text-white rounded-md px-4 py-2 hover:bg-[#333] transition-colors duration-200 shadow"
            onClick={() => handleRenderPolyline({ item })}
          >
            {t("mapMonitor.history")}
          </button>

          <button
            className="w-full bg-[#222] text-white rounded-md px-4 py-2 hover:bg-[#333] transition-colors duration-200 shadow"
            onClick={async () => handleViewDetailTrip({ item })}
          >
            {t("mapMonitor.detail")}
          </button>
        </div>
      </InfoWindow>
    );
  };
  if (loadError) return null;
  if (!isLoaded) return null;

  return (
    <GoogleMap
      mapContainerClassName="w-full h-full"
      zoom={zoom}
      center={center}
      options={{
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
      }}
    >
      {filterresTrip.map((item, index) => {
        const tripId = item.trip.id;
        // Asignar color si no existe para este trip

        if (!truckColors[tripId]) {
          setTruckColors(prev => ({
            ...prev,
            [tripId]: getRandomCabColor(item.lastMovementStatus)
          }));
        }
        
        const randomCabColor = item?.isNew ? '#E8B024' : truckColors[tripId] || getRandomCabColor();
        const rotation = item.currentLocation.rotation || 0;
        
        const iconProperties = createTruckIcon(rotation, randomCabColor);

        return (
          <>
            <Marker
              position={item.currentLocation}
              icon={iconProperties}
              key={`marker_${index}`}
              onClick={() => {
                setActiveView(index);
              }}
            >
              {activeView === index && handleRenderInfoView({ index, item })}
            </Marker>
            {item.isDangerZone && (
              <Circle
                center={item.currentLocation}
                radius={30}
                options={{
                  fillColor: "#FFBB35",
                  strokeColor: "#FFBB35",
                }}
                key={`circle_${index}`}
              />
            )}
          </>
        );
      })}

      {zonesGeofences?.map((item) => {
        return (
          <Circle
            center={{ lat: item.latitude, lng: item.longitude }}
            radius={item.radio}
            options={{
              fillColor: "#F9C3B7",
              fillOpacity: 0.35,
              strokeColor: "#FA9F8B",
              strokeOpacity: 0.8,
              strokeWeight: 1,
              clickable: true,
              zIndex: 1,
            }}
            onClick={() => {
              // Puedes abrir un InfoWindow u otra acción
              console.log(`Clicked on geofence ${item.id}`);
            }}
            key={`geofence_${item.id}`}
          />
        );
      })}

      <Polyline
        path={paths?.paths ? paths.paths : []}
        options={{ fillColor: "#21282e", strokeWeight: 2 }}
        key="path"
        visible={visiblePoliLyne}
      />

      <button
        className={`font-[Gravity] text-sm  text-white absolute bottom-20 right-2 rounded-full w-12 h-12 z-[9999] shadow-lg hover:bg-[#333] transition-all duration-200 ${
          visiblePoliLyne ? "bg-white" : "hidden"
        }`}
        onClick={() => {
          setVisiblePoliLyne(false);
        }}
        title={t("mapMonitor.delete_history")} // ayuda accesible
      >
        🗑️
      </button>

      {infoTrip && (
        <ModalDetailTrip
          isOpen={true}
          onClose={() => {
            setInfoTrip(null);
          }}
          data={infoTrip}
        />
      )}
    </GoogleMap>
  );
};

export default MapMonitor;
